import { Injectable } from "@angular/core";
import { Branches } from "../enums/branches";
import { Policy } from "../models/policy";
import { PolicyDetail } from "../models/policy-details";
import { Quotation, QuotationDetail } from "../models/quotation";

@Injectable({
  providedIn: "root",
})
export class OffersTypeService {
  isPolicyBranch(policy: Policy, comparator: Branches): boolean {
    return policy && policy.branchCode === comparator;
  }

  isQuotationBranch(quotation: Quotation, comparator: Branches): boolean {
    return quotation && quotation.branchCode === comparator;
  }

  isPolicyDetailsBranch(policyDetails: PolicyDetail, comparator: Branches) {
    return policyDetails && policyDetails.branchCode === comparator;
  }

  isQuotationDetailsBranch(quotationDetails: QuotationDetail, comparator: Branches): boolean {
    return quotationDetails && quotationDetails.branchCode === comparator;
  }
}
